export type TournamentLifecycleKind = 'upcoming' | 'active' | 'finished';

export type TournamentLifecycleSource = {
  startDate?: Date | string;
  endDate?: Date | string;
  isStarted?: boolean;
  isFinished?: boolean;
};

const startOfDay = (value?: Date | string): Date | undefined => {
  if (!value) return undefined;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export function getTournamentLifecycle(
  tournament: TournamentLifecycleSource,
  now: Date = new Date()
): TournamentLifecycleKind {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const start = startOfDay(tournament.startDate);
  const end = startOfDay(tournament.endDate);

  if (tournament.isFinished || (end && end < today))
    return 'finished';

  if (tournament.isStarted || (start && start <= today))
    return 'active';

  return 'upcoming';
}

export function tournamentLifecycleLabel(kind: TournamentLifecycleKind): string {
  switch (kind) {
    case 'active':
      return 'Идёт сейчас';
    case 'upcoming':
      return 'Предстоящий';
    case 'finished':
      return 'Завершён';
  }
}
